import { VehicleFilters } from "../features/Filters/VehicleFilters";

export const MyVehiclesActions = () => {
  return (
    <div className="mt-2">
      <VehicleFilters.ActiveFilters />
    </div>
  );
};
